import Head from "next/head";

const SITE_ORIGIN = "https://www.chesshotel.com";

function plainText(value: unknown): string {
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(plainText).join(" ");
  if (!value || typeof value !== "object") return "";

  const node = value as { text?: unknown; children?: unknown[] };
  if (typeof node.text === "string") return node.text;
  return Array.isArray(node.children)
    ? node.children.map(plainText).join(" ")
    : "";
}

export default function PostMetadata({
  post,
  path,
}: {
  post: any;
  path: string;
}) {
  const title = `${plainText(post.title) || "Chess Guide"} | Chess Hotel`;
  const description =
    [post.excerpt, post.description, post.subtitle]
      .map(plainText)
      .find((value) => value.trim())
      ?.replace(/\s+/g, " ")
      .trim() || `Read ${plainText(post.title) || "this chess guide"} on Chess Hotel.`;
  const url = new URL(path, SITE_ORIGIN).toString();
  const imageUrl = post.heroImg
    ? new URL(post.heroImg, SITE_ORIGIN).toString()
    : undefined;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={url} />
      {imageUrl && <meta property="og:image" content={imageUrl} key="og-image" />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
    </Head>
  );
}
